import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid red",
  boxShadow: 24,
  p: 4,
};
const ProjectModal = ({ open, handleClose, project }) => {
  console.log("project modal", project);
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Card sx={{ maxWidth: 690, height: 520 }}>
            <CardMedia
              component="img"
              alt="green iguana"
              height="340"
              image={project?.img}
            />
            <CardContent sx={{ height: 250, overflow: "scroll" }}>
              <Typography gutterBottom variant="h5" component="div">
                {project?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {project?.tech}
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography mt={1} variant="body2" color="text.secondary">
                  <span style={{ fontSize: 17, color: "black" }}>Details:</span>{" "}
                  {project?.info}
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Box>
      </Modal>
    </div>
  );
};

export default ProjectModal;
